<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <app-api-table
      [endpoint]="'/promoter-sales/tables/catalogue-analytics'"
      [name]="name"
      [chartColumn]="'Catalogue'"
      [hasIndexCol]="true"
    ></app-api-table>
  }
</app-tab-layout>
